import { BackgroundColor } from "@silversea-ssc/ui-components-react";
import ConfiguredConfigure from "components/Algolia/ConfiguredConfigure";
import { ConfiguredInstantSearch } from "components/Algolia/ConfiguredInstantSearch";
import CruisesSliderHits, {
  CruisesSliderHitsProps
} from "components/Algolia/CruisesSliderHits";
import { cruiseAttributesToRetrieve } from "components/FindYourCruise/Components/utils";
import { FYCQuery } from "components/FindYourCruise/FYCQueryBuilder";
import { useFYC } from "components/FindYourCruise/useFYC";
import React, { useMemo } from "react";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import { useLanguage } from "src/utils/localization/languages/I18nContext";

type Props = Pick<CruisesSliderHitsProps, "promosContent" | "shipsContent"> & {
  searchQuery: FYCQuery;
  showDestination?: boolean;
  variantColor: BackgroundColor;
};

const CruiseSliderBase: React.FC<Props> = ({
  searchQuery,
  variantColor,
  showDestination,
  shipsContent,
  promosContent
}) => {
  const language = useLanguage();
  const { countryCode } = useGeolocation();
  const attributesToRetrieve = useMemo(
    () => cruiseAttributesToRetrieve(language, countryCode),
    [language, countryCode]
  );

  const { filterDefaultSearch, localizedSearchIndexName } = useFYC(searchQuery);
  if (!localizedSearchIndexName) return null;

  return (
    <ConfiguredInstantSearch indexName={localizedSearchIndexName}>
      <ConfiguredConfigure
        filters={filterDefaultSearch}
        distinct
        offset={0}
        length={20}
        attributesToRetrieve={attributesToRetrieve}
      />

      <CruisesSliderHits
        variantColor={variantColor}
        showDestination={showDestination}
        promosContent={promosContent}
        shipsContent={shipsContent}
      />
    </ConfiguredInstantSearch>
  );
};

export default CruiseSliderBase;
